import * as React from 'react';
import { ChoiceGroup, MessageBar, MessageBarType } from 'office-ui-fabric-react';
import { ConfirmationDialog } from '../common/ConfirmationDialog';
import { ModeSwitchRecalculation, ModeSwitchRecalculationInfo } from '../../entities/common';

type Props = {
    info: ModeSwitchRecalculationInfo;
    onDismiss: () => void;
    onApply: (recalculation: ModeSwitchRecalculation) => void;
}

type Option = {
    key: ModeSwitchRecalculation;
    text: string;
    description: string;
}

const OPTIONS: Option[] = [
    {
        key: ModeSwitchRecalculation.KeepEffortAndUnits,
        text: 'Keep effort & units, recalculate duration',
        description: 'Duration will adjust to fit the current work estimate. Best when completed work has already been logged.'
    },
    {
        key: ModeSwitchRecalculation.KeepDurationAndUnits,
        text: 'Keep duration & units, recalculate effort',
        description: 'Effort will be derived from the current duration and assignments. Recommended when no work has been logged yet.'
    }
];

const KEEP_DURATION_AND_EFFORT_OPTION: Option = {
    key: ModeSwitchRecalculation.KeepDurationAndEffort,
    text: 'Keep duration & effort, recalculate units',
    description: "Units will be derived from the current duration and effort. Best when the timeline and work estimate are both fixed and shouldn't change."
};

export default class TaskModeSwitchRecalculationDialog extends React.Component<Props, { recalculation: ModeSwitchRecalculation }> {
    constructor(props: Props) {
        super(props);
        this.state = { recalculation: OPTIONS[0].key };
    }

    render() {
        const { info } = this.props;
        const options = info.allowKeepDurationAndEffort ? [...OPTIONS, KEEP_DURATION_AND_EFFORT_OPTION] : OPTIONS;
        return <ConfirmationDialog
            onDismiss={this.props.onDismiss}
            onYes={() => this.props.onApply(this.state.recalculation)}
            onNo={() => { }}
            yesButtonProps={{ text: "Apply" }}
            noButtonProps={{ text: "Cancel" }}
            dialogContentProps={{
                title: 'Changing Task Mode',
                subText: info.taskCount > 1
                    ? `Switching the task mode from Manual to Auto requires recalculating ${info.taskCount} selected tasks. Choose what to preserve:`
                    : 'Switching the task mode from Manual to Auto requires recalculating this task. Choose what to preserve:'
            }}>
            <ChoiceGroup
                selectedKey={`${this.state.recalculation}`}
                onChange={(e, option) => option && this.setState({ recalculation: Number(option.key) as ModeSwitchRecalculation })}
                options={options.map(_ => ({
                    key: `${_.key}`,
                    text: _.text,
                    onRenderField: (fieldProps, render) => <>
                        {render!(fieldProps)}
                        <p>{_.description}</p>
                    </>
                }))}
            />
            <MessageBar messageBarType={MessageBarType.warning} isMultiline>
                The re-calculation cannot be undone.
            </MessageBar>
        </ConfirmationDialog>;
    }
}
